/**
 * Navegação para fora da SPA. Isolada num módulo para os testes trocarem por um espião: o
 * `window.location` do jsdom não deixa redefinir o `assign`.
 *
 * Quem chama passa só uma URL que a API devolveu (a `redirectUrl` do consentimento do MCP), nunca
 * um valor da query da página nem do storage. Nada aqui registra a URL, que pode carregar o code.
 */
export function assignLocation(url: string): void {
  window.location.assign(url);
}

/**
 * Recarrega o backoffice na tela de login, descartando a memória da aba (o access token e o
 * operador). Destino fixo, nunca vindo da API, da query ou do storage.
 */
export function goToLoginPage(): void {
  window.location.href = '/login';
}
